import React, { useCallback, useContext, useRef, useState } from 'react'
import Draggable from 'react-draggable'

import { AppStateContext } from '../AppStateContext'
import Panel from '../../../elem/panel/Panel'
import WellDetailPanelHeader from './WellDetailPanelHeader'
import DataContextProvider from './DataContext'
import NitrateChart from './NitrateChart'
import DetailTabs from './DetailTabs'
import WellDetails from './WellDetails'
import ScreenDetails from './ScreenDetailList'
import SampleDetails from './SampleDetailList'
import TimeWindowDropdown from './TimeWindowDropdown'
import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'

const Detail = () => {
    const { detailState } = useContext(AppStateContext)
    const visible = detailState.well.visible
    const chartRef = useRef(null)

    return (
        <Draggable
            bounds="parent"
            handle=".wellDetailPanelHeader"
            positionOffset={{ x: '.75rem', y: '.75rem' }}
        >
            <div
                className={`column is-4-desktop is-half-tablet is-full-mobile detailPanelWrapper ${
                    !visible ? 'is-invisible' : ''
                }`}
            >
                <Panel panelClassConfig={panelClassConfig()}>
                    <DataContextProvider>
                        <WellDetailPanelHeader chartRef={chartRef} />
                        <div className="wellDetailWrapper">
                            <TimeWindowDropdown />
                            <div ref={chartRef} className={'chart'}>
                                <NitrateChart />
                            </div>
                            <DetailTabs />
                            <WellDetails />
                            <ScreenDetails />
                            <SampleDetails />
                        </div>
                    </DataContextProvider>
                </Panel>
            </div>
        </Draggable>
    )
}

export default Detail
